import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  forwardRef,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges
} from "@angular/core";
import {  MatSnackBar } from "@angular/material/snack-bar";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import {
  FormGroup,
  FormControl,
} from "@angular/forms";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MasterService } from "../../../services/masters.service";

@Component({
  selector: "app-master-form-field",
  templateUrl: "./master-form-field.component.html",
  styleUrls: ["./master-form-field.component.scss"],
  providers: [ { 
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MasterFormFieldComponent),
    multi: true,
  }]
})
export class MasterFormFieldComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {
  
  list: any = [];
  isValid: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() label: string;
  @Input() masterName: string;
  @Input() formControlName: string;
  @Input() defaultValue: any;
  @Input() parentForm: FormGroup;
  @Input() isSubmitted: boolean;
  @Input() params: object;
  @Output() itemSelected: EventEmitter<any> = new EventEmitter();
  @Output() autoLoadCompleted: EventEmitter<any> = new EventEmitter();
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  @Input() allowNA: boolean = false;

  public filterCtrl: FormControl = new FormControl();
  public filteredList: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  constructor(
    public snackBar: MatSnackBar,
    private masterService: MasterService
  ) {}

  ngOnInit() {
    this.validateField();

    this.filterCtrl.valueChanges
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => {
        this.filterList();
      });

    this.parentForm.controls[this.formControlName].valueChanges
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => this.syncControlValue());

    if(this.params != undefined){
      this.getListWithParams();
    }
    else if(this.params !== null){
      this.getList();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["params"] && changes["params"].currentValue != null && changes["params"].currentValue != changes["params"].previousValue)
      this.getListWithParams();

    if(changes["defaultValue"] && changes["defaultValue"].currentValue != null && changes["defaultValue"].currentValue != changes["defaultValue"].previousValue){
      if(this.params != undefined){
        this.getListWithParams();
      }else{
        this.getList();
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  /**
   * 
   * @returns null if validation fails
   */
  protected filterList() {
    // to filters datsbase on key
    if (!this.list) {
      return;
    }
    // get the search keyword
    let search = this.filterCtrl.value;
    if (!search) {
      this.filteredList.next(this.list.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredList.next(
      this.list.filter(
        e => e.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }

  /**
   * ControlValueAccessor lifecycle events
   * Should not be removed
   */
  writeValue(){ }
  registerOnChange(){}
  registerOnTouched(){}

  /**
   * Form validation
   */
  validateField(){
    this.isValid = this.parentForm.controls[this.formControlName].valid;
    if(this.isValid)
      this.notifySelection(this.parentForm.controls[this.formControlName].value);
  }

  /**
   * To get generic master
   */
  getList() {
    if(this.masterName.includes('query'))
      {
        if(this.params != undefined && this.params!=null && this.defaultValue != null && this.defaultValue!=undefined)
          this.getListData();
      }
      else
        this.getListData()
  }

  getListData()
  {
    this.masterService.getMaster(this.masterName).then(data => {
      this.list = data;
      this.filteredList.next(this.list.slice()); 
      this.applyDefaultValue(true);
      this.syncControlValue();
    });
  }

  /**
   * To get generic master with params
   */
   getListWithParams() {
    this.masterService.getMasterWithParams(this.masterName, this.params).then(data => {
      this.list = data;
      this.filteredList.next(this.list.slice()); 
      this.applyDefaultValue(true);
      this.syncControlValue();
    });
  }

  private applyDefaultValue(emitAutoLoadCompleted = false) {
    if (this.defaultValue == null || !this.list) {
      return;
    }

    const defaultCode = typeof this.defaultValue === "string"
      ? this.defaultValue
      : this.defaultValue.code;
    if (!defaultCode) {
      return;
    }

    const item = this.list.find(data =>
      data.code && data.code.toLowerCase() === defaultCode.toString().toLowerCase()
    );
    if (item) {
      this.parentForm.patchValue({
        [this.formControlName]: item
      });
      if (emitAutoLoadCompleted) {
        this.autoLoadCompleted.emit(item);
      }
    }
  }

  private syncControlValue() {
    if (!this.list || !this.parentForm) {
      return;
    }

    const control = this.parentForm.controls[this.formControlName];
    const value = control?.value;
    const code = typeof value === "string" ? value : value?.code;
    if (!code) {
      return;
    }

    const item = this.list.find(option =>
      option.code && option.code.toString().toLowerCase() === code.toString().toLowerCase()
    );
    if (item && value !== item) {
      control.patchValue(item, { emitEvent: false });
    }
  }

  /**
   * To emit event when item is selected
   * @param obj 
   */
  notifySelection(obj){
    if(obj != null)
      this.itemSelected.emit(obj);
  }
}
